import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { wysiwyg } from '../../../styleguide/exampledata/example-content';

@Component({
    selector: 'app-content-panel',
    imports: [NgClass],
    templateUrl: './content-panel.component.html',
    styleUrl: './content-panel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentPanelComponent {
  @Input() datacolor?: string;

  wysiwyg = wysiwyg;

  color() {
    if (this.datacolor === 'null' || !this.datacolor) {
      return 'light';
    }
    return this.datacolor;
  }
}
